const OPEN = Symbol('OPEN');

export default { OPEN };
